import { mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'

export default {
    components: {
        VueApexCharts
    },
    props: {
        series: {
            type: Array,
            default: () => [],
            validator: (series) => {
                return series
                    .selectMany((series) => series.data)
                    .all((item) => item.name && item.value !== null)
            }
        }
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters({
            themeMode: 'user/themeMode',
            isThemeDark: 'user/isThemeDark'
        }),
        seriesCount() {
            return this.series.length
        },
        isSingleSeries() {
            return this.seriesCount <= 1
        },
        allDataPoints() {
            return this.series.selectMany((series) => series.data)
        },
        allLabels() {
            return this.allDataPoints.distinct((e) => e.name)
        },
        noSeries() {
            return !this.series || !this.allDataPoints.any()
        }
    },
    methods: {
        getIdForDataPoint(dataPoint) {
            if (!dataPoint) {
                return null
            }
            return `${dataPoint.name}_${dataPoint.value}`
        },
        getDataPointById(id) {
            return this.allDataPoints.first((dataPoint) => this.getIdForDataPoint(dataPoint) === id)
        }
    },
    created() {}
}
